module.exports = __webpack_public_path__ + "img/a11y-stability-1_en.f624ff1.jpg";